export default "__VITE_ASSET__2dbb30ab__"